import { SxProps } from '@mui/material'

export default {
  service: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingBottom: 3,
    backgroundColor: '#FEF8F3',
    borderRadius: '4px',
  },
  image: {
    width: '100%',
    height: 'auto',
    borderRadius: '4px 4px 0 0',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    padding: 3,
  },
  cta: {
    width: 'fit-content',
    margin: '0 auto',
  },
} satisfies SxProps
